import { render, staticRenderFns } from "./ColaH.vue?vue&type=template&id=65892977&scoped=true"
import script from "./ColaH.vue?vue&type=script&lang=js"
export * from "./ColaH.vue?vue&type=script&lang=js"
import style0 from "./ColaH.vue?vue&type=style&index=0&id=65892977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65892977",
  null
  
)

export default component.exports